import React, { createContext, useContext, useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

interface PageContextValue {
  page: number;
  setPage: (page: number) => void;
  nextPage: () => void;
  prevPage: () => void;
  resetPage: () => void;
}

const PageContext = createContext<PageContextValue | undefined>(undefined);

export const PageProvider = ({ children }: { children: React.ReactNode }) => {
  const [page, setPageState] = useState<number>(0);
  const [searchParams] = useSearchParams();
  const orderTab = searchParams.get('orderTab');

  const setPage = (newPage: number) => {
    setPageState(Math.max(newPage, 0)); // 1페이지 이하로 내려가지 않도록
  };

  const nextPage = () => setPageState((prev) => prev + 1);
  const prevPage = () => setPageState((prev) => Math.max(prev - 1, 0));
  const resetPage = () => setPageState(0);

  useEffect(() => {
    resetPage();
  }, [orderTab]);

  return (
    <PageContext.Provider value={{ page, setPage, nextPage, prevPage, resetPage }}>
      {children}
    </PageContext.Provider>
  );
};

export const usePage = () => {
  const context = useContext(PageContext);
  if (!context) {
    throw new Error('usePage must be used within a PageProvider');
  }
  return context;
};
